var React = require('react');

function WInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#1b365d"},[React.createElement("path",{"d":"m7.13573 13.7854h4.33417l4.1 7.1014-2.1671 3.7533z","key":0}),React.createElement("path",{"d":"m19.6679 13.7885-.002-.0033h-4.3309l-.0013.0033 6.2644 10.8514 2.1677-3.754z","key":1}),React.createElement("path",{"d":"m26.05 17.6-2.15-3.8h4.3z","key":2}),React.createElement("path",{"clipRule":"evenodd","d":"m0 17.4997c0 9.6497 7.8506 17.5003 17.5003 17.5003 9.6498 0 17.5004-7.8506 17.5004-17.5003 0-9.6491-7.8506-17.4997-17.5004-17.4997-9.6497 0-17.5003 7.8506-17.5003 17.4997zm1.64544 0c0-8.74221 7.11205-15.85493 15.85486-15.85493 8.7429 0 15.8549 7.11272 15.8549 15.85493 0 8.7428-7.112 15.8555-15.8549 15.8555-8.74281 0-15.85486-7.1127-15.85486-15.8555z","fillRule":"evenodd","key":3})]));
}

WInline.defaultProps = {"fill":"none","height":"35","viewBox":"0 0 35 35","width":"35"};

module.exports = WInline;

WInline.default = WInline;
